/**
 * Haitian gourde.
 */
export var HTG = {
  code: 'HTG',
  base: 10,
  exponent: 2
};